import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { DateInput } from "../../../../../components";

export default class ReferralDatesTab extends Component {

    render() {
        const { referral, onReferralChange, readOnly } = this.props;

        return (
            <Container>
                <Row>
                    <Col>
                        <Field label="Requested Date" body={
                            <DateInput
                                className="whiteBackground"
                                value={referral.requestedDateTime}
                                disabled={readOnly}
                                onChange={(value) => onReferralChange && onReferralChange(referral.id, 'requestedDateTime', value)}
                            />
                        }/>
                    </Col>
                    <Col>
                        <Field label="Response Received Date" body={
                            <DateInput
                                className="whiteBackground"
                                value={referral.responseReceivedDateTime}
                                disabled={readOnly}
                                onChange={(value) => onReferralChange && onReferralChange(referral.id, 'responseReceivedDateTime', value)}
                            />
                        }/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

class Field extends Component {
    render() {
        const { label, body } = this.props;
        return (
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 12, gap: '4px' }}>
                <div style={{ fontWeight: 'bold' }}>{label}:</div>
                <div>{body}</div>
            </div>
        );
    }
}
